import { render, staticRenderFns } from "./JoinDisucssion.vue?vue&type=template&id=0288c33c"
import script from "./JoinDisucssion.vue?vue&type=script&lang=js"
export * from "./JoinDisucssion.vue?vue&type=script&lang=js"
import style0 from "./JoinDisucssion.vue?vue&type=style&index=0&id=0288c33c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports